/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Achievements_Search_WordsInputs */



/**
* | output |
* | --- |
* | "voice hours, voice time, voice rewards, playtime, game rewards, messages, statistics, threshold, permanent achievements, rolling window, Juniper" |
*
* @param {Perks_Achievements_Search_WordsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_achievements_search_words = /** @type {((inputs?: Perks_Achievements_Search_WordsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Achievements_Search_WordsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("часы в войсе, время в войсе, голосовые награды, награды за войс, голосовые каналы, плейтайм, время в игре, награды за игру, сообщения, статистика, порог, навсегда, последние дни, Джунипер, Juniper")
	return /** @type {LocalizedString} */ ("voice hours, voice time, voice rewards, playtime, game rewards, messages, statistics, threshold, permanent achievements, rolling window, Juniper")
});